<template>
  <a href="#" class="store_box" @click.prevent="$emit('select', item)">
    <BaseImage :src="imageSrc" alt="store game" />

    <div class="flex-column">
      <p class="title">
        <b v-if="isBonusPhaseEnabledAndValid" class="strikethrough">
          {{ preBonusPhaseNumberOfGames }}
        </b>

        {{ gamesText }}
      </p>
    </div>

    <div class="flex-row">
      <p class="price">{{ priceText }}</p>

      <i class="fas fa-chevron-right"></i>
    </div>
  </a>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import BaseImage from '@/components/image/BaseImage.vue';

defineEmits(['select']);

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
  bonusPhaseEnabled: {
    type: Boolean,
    default: false,
  },
});

const { proxy } = getCurrentInstance();

const isBonusPhaseEnabledAndValid = computed(() => props.bonusPhaseEnabled && (props.item.multiplier > 0));

const preBonusPhaseNumberOfGames = computed(() => isBonusPhaseEnabledAndValid.value
  ? Math.floor(props.item.noOfGames / props.item.multiplier)
  : 0);

const imageSrc = computed(() => isBonusPhaseEnabledAndValid.value
  ? '/static/images/store/store_games_icon.svg'
  : '/static/images/store/store_game_icon.svg');

const gamesText = computed(() => {
  const totalGames = props.item.noOfGames;

  return `${ totalGames } ${ proxy.$_translate(totalGames > 1 ? 'page_store_game_plural' : 'page_store_game') || '' }`;
});

const priceText = computed(() => `${ props.item.price } ${ props.item.currencyCode }`);
</script>
